import{createContext as r}from"react";var a=r(void 0);export{a as default};
//# sourceMappingURL=Context.js.map
